import { Chip } from '@/components/commons/chip'
import type { Image } from '@/features/photoset/types'
import { useTranslation } from '@/translations/i18n'

export const GalleryNeedsReviewSidebar = ({
	currentImage
}: {
	currentImage: Omit<Image, 'space'>
}) => {
	const { t } = useTranslation()
	const flags = currentImage.flags.filter(
		(flag) => flag.type === 'visual_retouching'
	)

	return (
		<div className='flex flex-col gap-4 p-4'>
			<h4 className='font-medium text-neutral-900 text-sm'>
				{t('common:flag', { count: 2 })}
			</h4>
			<div className='flex flex-wrap gap-1.5 [&>p]:text-sm'>
				{flags.length > 0 ? (
					flags
						.filter((flag) => flag.type === 'visual_retouching')
						.map((flag) => (
							<Chip
								isActive
								key={flag.id}
								label={t(
									`photoset:flags.${flag.key_name}.label`
								)}
								variant='info'
							/>
						))
				) : (
					<p>{t('photoset:needs_review.no_flags_fond')}</p>
				)}
			</div>
		</div>
	)
}
